module.exports = __webpack_public_path__ + "img/logo-wordmark.a459150b.png";